module.exports = __webpack_public_path__ + "img/frame_detection.e27ef4f9.png";